(() => {
  const rootPath = window.Shopify?.routes?.root || '/';
  let validationPromise = null;

  const fetchCart = async () => {
    const response = await fetch(`${rootPath}cart.js?_=${Date.now()}`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!response.ok) throw new Error('Não foi possível verificar o carrinho.');
    return response.json();
  };

  const parseExpected = (value) => {
    try {
      const parsed = JSON.parse(value || '{}');
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null;
      const clean = {};
      for (const [id, multiplier] of Object.entries(parsed)) {
        const variantId = Number(id);
        const amount = Number(multiplier);
        if (!Number.isInteger(variantId) || variantId <= 0 || !Number.isFinite(amount) || amount < 0) return null;
        clean[String(variantId)] = amount;
      }
      return clean;
    } catch (_) {
      return null;
    }
  };

  const validateCart = (cart) => {
    const items = cart?.items || [];
    const groups = new Map();

    items.forEach((item) => {
      const group = item.properties?._artes_personalization_group;
      if (!group) return;
      if (!groups.has(group)) groups.set(group, []);
      groups.get(group).push(item);
    });

    for (const [group, groupItems] of groups) {
      const parents = groupItems.filter((item) => item.properties?._artes_personalization_addon !== 'true');
      const helpers = groupItems.filter((item) => item.properties?._artes_personalization_addon === 'true');

      // Every guarded personalization group must have exactly one parent line.
      if (parents.length !== 1) return { ok: false, group };
      const parent = parents[0];
      if (parent.properties?._artes_personalization_guard_version !== '1') return { ok: false, group };

      const expected = parseExpected(parent.properties?._artes_personalization_expected_helpers);
      if (expected === null) return { ok: false, group };
      const parentQty = Math.max(1, Number(parent.quantity || 1));
      const actual = {};

      for (const helper of helpers) {
        if (helper.properties?._artes_personalization_parent !== String(parent.variant_id || parent.id)) {
          return { ok: false, group };
        }
        const id = String(Number(helper.variant_id || helper.id));
        actual[id] = (actual[id] || 0) + Number(helper.quantity || 0);
      }

      const expectedIds = Object.keys(expected).sort();
      const actualIds = Object.keys(actual).sort();
      if (expectedIds.join(',') !== actualIds.join(',')) return { ok: false, group };
      for (const id of expectedIds) {
        if (actual[id] !== expected[id] * parentQty) return { ok: false, group };
      }
    }

    // A helper line without any group is invalid as well.
    if (items.some((item) => item.properties?._artes_personalization_addon === 'true' && !item.properties?._artes_personalization_group)) {
      return { ok: false };
    }
    return { ok: true, hasPersonalization: groups.size > 0 };
  };

  const showError = (message) => {
    const targets = [document.getElementById('cart-errors'), document.getElementById('CartDrawer-CartErrors')].filter(Boolean);
    targets.forEach((target) => {
      target.textContent = message;
      target.setAttribute('role', 'alert');
    });
    if (!targets.length) window.alert(message);
  };

  const setCheckoutState = (valid, hasPersonalization = false) => {
    document.querySelectorAll('button[name="checkout"], #checkout, #CartDrawer-Checkout').forEach((button) => {
      if (valid) {
        if (button.dataset.artesGuardDisabled === 'true') button.disabled = false;
        delete button.dataset.artesGuardDisabled;
      } else {
        if (!button.disabled) button.dataset.artesGuardDisabled = 'true';
        button.disabled = true;
      }
    });
    // Accelerated/dynamic checkout cannot run our theme guard, so do not expose it
    // on carts containing personalised items. Standard Shopify checkout remains.
    document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons').forEach((el) => {
      el.hidden = Boolean(hasPersonalization);
    });
  };

  const runValidation = async () => {
    if (validationPromise) return validationPromise;
    validationPromise = (async () => {
      try {
        const cart = await fetchCart();
        const result = validateCart(cart);
        setCheckoutState(result.ok, result.hasPersonalization);
        if (!result.ok) {
          showError('Existe um problema com os valores da personalização no carrinho. Por segurança, o checkout foi bloqueado. Remove o produto personalizado e adiciona-o novamente.');
        }
        return result;
      } catch (error) {
        console.error('Personalization checkout validation failed', error);
        setCheckoutState(false, true);
        showError('Não foi possível verificar a personalização. Atualiza a página e tenta novamente.');
        return { ok: false };
      } finally {
        validationPromise = null;
      }
    })();
    return validationPromise;
  };

  const checkoutAttempt = async (event) => {
    const checkoutButton = event.target.closest?.('button[name="checkout"], #checkout, #CartDrawer-Checkout');
    if (!checkoutButton) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const result = await runValidation();
    if (result.ok) window.location.assign(`${rootPath}checkout`);
  };

  document.addEventListener('click', checkoutAttempt, true);
  document.addEventListener('submit', async (event) => {
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const result = await runValidation();
    if (result.ok) window.location.assign(`${rootPath}checkout`);
  }, true);

  document.addEventListener('DOMContentLoaded', runValidation);
  document.addEventListener('shopify:section:load', runValidation);
  document.addEventListener('cart:refresh', runValidation);
  if (document.readyState !== 'loading') runValidation();
})();
